import { motion, Variants } from "framer-motion";
import "./Timeline.css";

export function Timeline() {
  let zero = new TimelineItem(
    "Amita Care (Pearlss4 Development)",
    "Android Developer",
    "@Amita Care (Pearlss4 Development)",
    "Amita.png",
    "https://amitacare.com/",
    "Jan 2023 - April 2023",
    [
      "Developed a Mental Health Application based on the client's existing Website",
      "The app helps patients diagnose problems,recommends doctors, facilitates appointment scheduling and enables payment for medical services."
    ],
    [
      "Flutter",
      "Firebase",
      "Dart",
      "API Gateway",
      "PayPal API",
      ]
  );
  let one = new TimelineItem(
    "Glocybs",
    "Front-End Web & Android Developer",
    "@Glocybs",
    "Glocybs.png",
    "https://glocybs.com/",
    "Aug 2024 - Present",
    [
      "Currently creating a dynamic wesbite for the company",
      "The website allows clients to look at the company's services and contact them",
      "Working on the mobile application for the company for the same purpose",
    ],
    [
      "Flutter",
      "React.js",
      "Typescript",
      "Dart",
      "TailwindCSS",
      "Framer Motion",
    ]
  );  
  return (
    <div className="about-timeline-container">
      <div className="about-timeline">
        {/* Items */}
        {zero.display()}
        {one.display()}
        </div>
    </div>
  );
}

class TimelineItem {
  id: string;
  role: string;
  company: string;
  logo: string;
  link: string;
  date: string;
  desc: string[];
  stack: string[];

  constructor(
    id: string,
    role: string,
    company: string,
    logo: string,
    link: string,
    date: string,
    desc: string[],
    stack: string[]
  ) {
    this.id = id;
    this.role = role;
    this.company = company;
    this.logo = logo;
    this.link = link;
    this.date = date;
    this.desc = desc;
    this.stack = stack;
  }

  openSocial = (socialLink: string) => {
    window.open(socialLink);
  };

  display() {
    return (
      <motion.div
        className="about-timeline-item"
        transition={{
          duration: 0.8,
          delay: 0,
        }}
        initial="offscreen"
        whileInView="onscreen"
        variants={itemVariants}
        viewport={{ once: true }}
      >
        <div className="about-timeline-item-container">
          <div className="about-timeline-item-context">
            <div className="timeline-row">
              <div className="timeline-col">
                <div className="about-timeline-item-role">{this.role}</div>
                <div
                  className="about-timeline-item-company about-body-link"
                  onClick={() => {
                    this.openSocial(this.link);
                  }}
                >
                  {this.company}
                </div>
              </div>

              <div className="timeline-logo-container">
                <img
                  id={this.id}
                  onClick={() => this.openSocial(this.link)}
                  className="about-timeline-item-logo"
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/timeline_assets/" +
                    this.logo
                  }
                  alt="work-logo"
                />
              </div>

              <div className="hidden-timeline-date">{this.date}</div>
            </div>

            <div className="row about-timeline-item-bottom">
              <div className="about-timeline-item-dates">{this.date}</div>
            </div>

            <div className="timeline-header">
              <div className="timeline-item-desc">
                {this.desc.map((e) => {
                  return <li key={e}>{e}</li>;
                })}
              </div>
            </div>

            <div className="row about-timeline-item-bottom">
              {this.stack.map((e) => {
                return (
                  <div key={e} className="timeline-item-tags">
                    {e}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </motion.div>
    );
  }
}

const itemVariants: Variants = {
  offscreen: {
    scale: 0,
  },
  onscreen: {
    scale: 1,
    transition: {
      type: "spring",
      bounce: 0.5,
      duration: 1,
    },
  },
};
